import { Component } from '@angular/core';
import { ManageIgmContainerComponent } from './manage-container/igm-container.component';
import { ManageIGMVesselComponent } from './manage-vessel/igm-vessel.component';

@Component({
  selector: 'app-manage-igm',
  standalone: true,
  imports: [ManageIgmContainerComponent, ManageIGMVesselComponent],
  templateUrl: './manage-igm.component.html',
  styleUrl: './manage-igm.component.scss'
})
export class ManageIgmComponent {
  selectedTab: string = 'vessel';

  constructor() {}

  selectTab(tabName: string) {
    this.selectedTab = tabName;
  }
}
